<div class="phone-control">
  <form [formGroup]="form">
    <country-picker-v2
      #countryPickerComponent
      [phoneFlagName]="phoneFlagName"
      [form]="form"
      [disabled]="disabled"
      [emitter]="changesEmitter"
    />
    <input-v2
      class="number-control"
      type="number"
      [placeholder]="inputPlaceholder ? inputPlaceholder : ''"
      [formControlName]="phoneName"
      [disabled]="disabled"
      #input
    />
  </form>
</div>
